const validateAccess = {
  title: 'Gerar senha de acesso para validação',
  description:
    'Ao submeter o documento digital para gerar senha de acesso a terceiros, estou ciente que este documento ficará disponível por 12 meses, sob segurança de senha.',
  help: 'Para retirar a disponibilidade entre em ',
  contact: 'contato',
  contactLink: 'https://www.clicksign.com/suporte',
};

export default validateAccess;
